import apolloClient from 'api/apolloClient';
import { makeAutoObservable } from 'mobx';
import { EnrollType, InputPerformedBy, ProductLine, ProductType } from 'types/enrollmentService';
import { SAVE_PROPOSAL } from 'api/enrollmentService';
import { Cart } from 'types/cartService';
import { PRODUCT_LINES_CONTENT_MAP } from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';

export class EnrollmentStore {
  // eslint-disable-next-line class-methods-use-this
  async saveProposal(
    groupId: string,
    cart: Cart,
    cartName: string,
    inputProductLines: ProductLine[],
    sponsorId: string,
    enrollType: EnrollType,
    createdBy?: InputPerformedBy,
  ): Promise<void> {
    await apolloClient.mutate({
      mutation: SAVE_PROPOSAL,
      variables: {
        sponsorId,
        proposal: {
          groupId,
          cartId: cart.id,
          cartName,
          effectiveDate: cart.lastUpdateBrowsingCriteria.effectiveDate,
          productLines: inputProductLines,
          createdBy,
          enrollType,
        },
        rateSegment:
          inputProductLines.length > 0 ? PRODUCT_LINES_CONTENT_MAP[inputProductLines[0].id].rateSegment : 'GROUP',
      },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  convertNewSaleCartIntoProductLine(cart: Cart): ProductLine[] {
    const pLines: ProductLine[] = [];
    const pLinesInCart = [...new Set(cart.cartItems.map((item) => item.productLineId))];
    pLinesInCart.forEach((lineId) =>
      pLines.push({
        id: lineId,
        productType: ProductType.NEW_SALE,
        confirmedPortfolioId: null,
        browsingCriteria: cart.lastUpdateBrowsingCriteria,
      }),
    );
    return pLines;
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
